// setMessageReplyInputValue.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set message reply input value
 * @kind action
 * @param {string} {messageId} - message id.
 * @param {string} {text} - reply message text.
 * @param {object} {media} - reply message media.
 * @return {Promise} Action promise.
 */
const setMessageReplyInputValue =
  ({ messageId, text, media }) =>
  async dispatch => {
    const selectPath = ['message', messageId];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        data: { replyInputText: text, replyMedia: media },
        selectPath,
      },
    });
  };

export default setMessageReplyInputValue;
